import { render, staticRenderFns } from "./ActivationBriefShippingRouterView.vue?vue&type=template&id=1e7ca904&"
import script from "./ActivationBriefShippingRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefShippingRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports